module.exports = __webpack_public_path__ + "img/ipad_cn.0a1d56f.jpg";